/**
 * @generated SignedSource<<38cf78518107687e315123d065e0fb7f>>
 * @relayHash 5b417ad5f6cdb797fc9abfb3c339a82f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-admin-accounts/560.0.0-2026-05-19T17:25:44.175Z/InternalLoginFormQuery

import { ConcreteRequest } from 'relay-runtime';
export type InternalLoginFormQuery$variables = Record<PropertyKey, never>;
export type InternalLoginFormQuery$data = {
  readonly viewer: {
    readonly internalLoginOktaSaml: boolean | null;
    readonly useOktaLogin: boolean | null;
  };
};
export type InternalLoginFormQuery = {
  response: InternalLoginFormQuery$data;
  variables: InternalLoginFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "internalLoginOktaSaml",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "internalLoginOktaSaml"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"internalLoginOktaSaml\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useOktaLogin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalLoginFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InternalLoginFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-admin-accounts/560.0.0-2026-05-19T17:25:44.175Z/InternalLoginFormQuery",
    "metadata": {},
    "name": "InternalLoginFormQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7e3a3d86ed3821ffe747ee23b5ea440c";

export default node;
